import { Plugin, createDropdown, addListToDropdown, ButtonView, Collection, UIModel, viewToModelPositionOutsideModelElement, } from 'ckeditor5';
import { v4 as uuid } from 'uuid';
import { PlaceholderStore } from './store';
/**
 * This plugin adds a toolbar to the editor to create and select placeholders.
 */
export class PlaceholderToolbar extends Plugin {
    static get pluginName() {
        return 'PlaceholderToolbar';
    }
    static get requires() {
        return [PlaceholderStore];
    }
    init() {
        this.store = this.editor.plugins.get(PlaceholderStore);
        this.registerNewPlaceholderButton();
        this.registerPlaceholderDropdown();
        this.store.placeholderData.on('change', () => {
            this.refreshDropdown();
        });
        this.dropdownView.on('execute', (event) => {
            const { label } = event.source;
            this.insertPlaceholderAtSelection(label);
        });
        this.editor.editing.mapper.on('viewToModelPosition', viewToModelPositionOutsideModelElement(this.editor.model, (viewElement) => viewElement.hasClass('placeholder')));
    }
    /**
     * Insert a placeholder at the current selection in the editor, and register it in the store.
     * @param id The id of the placeholder to insert. If not provided, a temporary id will be used.
     */
    insertPlaceholderAtSelection(id) {
        const { model } = this.editor;
        const { selection } = model.document;
        const tempId = uuid();
        const placeholderId = id || tempId;
        model.change((writer) => {
            const placeholder = writer.createElement('placeholder', { id: placeholderId });
            model.insertObject(placeholder, selection, null, { setSelection: 'after' });
        });
    }
    registerNewPlaceholderButton() {
        const { editor } = this;
        editor.ui.componentFactory.add('placeholderCreate', () => {
            const button = new ButtonView();
            button.set({
                label: 'Create placeholder',
                withText: true,
                class: 'pleditor-toolbar-fa-icon-button',
            });
            button.on('execute', () => {
                this.insertPlaceholderAtSelection();
            });
            return button;
        });
    }
    registerPlaceholderDropdown() {
        this.dropdownItemCollection = new Collection();
        this.dropdownView = createDropdown(this.editor.locale);
        addListToDropdown(this.dropdownView, this.dropdownItemCollection);
        this.editor.ui.componentFactory.add('placeholderDropdown', () => this.dropdownView);
        this.dropdownView.render();
        this.refreshDropdown();
    }
    refreshDropdown() {
        const items = this.store.getAllPlaceholdersFromStore();
        this.dropdownItemCollection.clear();
        items.forEach((name) => {
            this.dropdownItemCollection.add({
                type: 'button',
                model: new UIModel({
                    withText: true,
                    label: name,
                }),
            });
        });
    }
}
